import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { LOGIN_BEGIN, logError, fetchSocialConfig, getTweetVersion, registerEndpoint } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
// login to engagement server
export default function login(action$, state$) {
    return action$.pipe(ofType(LOGIN_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.readConfiguration().then(function(param) {
            var api_url = param.api_url, api_key = param.api_key;
            SocialAPIUtils.setAPIConfig(api_url, api_key);
            if (state$.value.student) {
                // The actual login routine.
                // This is a weird function with a lot of nested async logic inside!
                // TO DO: Is it possible to migrate this to an epic using rxjs?
                SocialAPIUtils.createTokenBasedSession(state$.value.student);
            } else {
                console.error('Tweet session cannot be created - value for "student" needed for creating a session is null or undefined!');
            }
            return {
                api_url: api_url,
                api_key: api_key
            };
        })).pipe(switchMap(function(response) {
            return [
                registerEndpoint({
                    endpoint: response.api_url,
                    key: "tweet"
                }),
                fetchSocialConfig(),
                getTweetVersion()
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "tweet_login"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "tweet_login"
        }));
    }));
}
